import { handleNumberField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { NumberSliderFieldControl } from "./NumberSliderFieldControl/NumberSliderFieldControl";
import { NumberSliderFieldValue } from "@smartsuite/types";
import { defaultToReviewString } from "../review/reviewString.helpers";

export const numberSlideFieldConfig: FieldRegistryConfig<NumberSliderFieldValue> = {
  icon: "number-slider",
  control: (props) => <NumberSliderFieldControl {...props} />,
  prefill: handleNumberField,
  toReviewString: defaultToReviewString,
};
